/* src/util/numbers.js */

import _ from 'lodash';

export const average = collection =>
  _.reduce(collection, (r, v) => r + v, 0) / _.size(collection);

export const zeroPad = num => (num < 10 ? `0${num}` : `${num}`);



// WEBPACK FOOTER //
// ./src/util/numbers.js